import { all, call } from "redux-saga/effects";
import onGetAllFaculty from "./getAllFaculties";
import onCreateFaculty from "./createFaculty";
import onEditFaculty from "./editFaculty";
import onDeleteFaculty from "./deleteFaculty";

export default function* facultiesSaga() {
  yield all([
    call(onGetAllFaculty),
    call(onCreateFaculty),
    call(onEditFaculty),
    call(onDeleteFaculty),
  ]);
}
